export default __webpack_public_path__ + "static/media/filter_icon.3ed99bce.svg";